import React from 'react';
import { Row, Spin } from 'antd';

const Loader: React.FC = () => {
  return (
    <Row align={'middle'} justify={'center'} style={{ minHeight: '100vh' }}>
      <Spin size={'large'} />
    </Row>
  );
};
export default Loader;
